module.exports = "/images/person.svg?1a45c8a6b0d1d1de60ea77723ceee873";